import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import { PackagesBook } from "./component";
import { getHotelShopChosenProduct } from "../hotel-shop/reducer";

const mapStateToProps = (state: IStoreState) => ({
  chosenProduct: getHotelShopChosenProduct(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesBookConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPackagesBook = withRouter(connector(PackagesBook));
